// extracted by mini-css-extract-plugin
export default {"footerContainer":"BottomFooter_footerContainer__5pJo3","leftContainer":"BottomFooter_leftContainer__9a78r","rightContainer":"BottomFooter_rightContainer__ooCd2"};